
    import Component from "vue-class-component";
    import FileUploaderBase from "@/components/FileUploaderBase";
    import VueFilePond from "vue-filepond";
    import filePondLocalization from '@/components/filePondLocalization';
    import {Prop} from "vue-property-decorator";

    const FilePond = VueFilePond();
    @Component({
        components: {
            FilePond
        }
    })
    export default class FileUploader extends FileUploaderBase{
        @Prop({ default: 10 })
        maxFiles!: number;
        
        filePondLocalization = filePondLocalization;
    }
